










import Vue from "vue";
import SimpleNavTabs from "@/components/SimpleNavTabs.vue";
import { state } from "./data/state";
export default Vue.extend({
  components: { SimpleNavTabs },
  setup() {
    const { tabs, current_tab, set_current_tab } = state;
    return { tabs, current_tab, set_current_tab };
  },
});
